import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { requestCloseModal } from "@/redux/actions/modal";
import { setProcessingState } from "@/redux/reducers/modalConfirmation";
import { lenderResourceShareService } from "@/modules/contacts/features/lender/store/resource-share-services/lender-resource-share-service";
import { RESOURCE_SHARE_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/resource-share-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const deleteResourceShare = lenderResourceShareService.injectEndpoints({
  endpoints: builder => ({
    deleteResourceShare: builder.mutation({
      query: ({ lenderId, resourceShareId }) => ({
        url: `lenders/${lenderId}/resource-shares/${resourceShareId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: RESOURCE_SHARE_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          dispatch(setProcessingState(true));
          const { data } = await queryFulfilled;

          sendAnalytics(ANALYTIC_EVENTS.RESOURCE_SHARE_DELETED, data);

          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Resource has been deleted successfully!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );

          dispatch(requestCloseModal());
          dispatch(setProcessingState(false));
        } catch (err) {
          Bugsnag.notify(err);
          dispatch(setProcessingState(false));
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDeleteResourceShareMutation } = deleteResourceShare;

